/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SpecialOrderMaterialStatusGroupModel} from '../../api/ms-specialorders/contracts/special-order-material-status-group.model';

@Component({
    selector: 'app-single-material-status',
    templateUrl: './single-material-status.component.html',
    styleUrls: ['./single-material-status.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SingleMaterialStatusComponent {

    @Input() specialOrderMaterialGroupStatus: SpecialOrderMaterialStatusGroupModel;
    @Input() totalOfMaterials: number;
    @Input() isDisabled: boolean;
    @Input() retryClick: Function;

    constructor() {
    }

    /**
     * Returns the percentage of materials in each status
     * @param materialsInStatus The number of materials in a specific status
     * @param totalMaterials The total number of materials
     */
    getMaterialInStatusPercentage(materialsInStatus: number, totalMaterials: number): number {
        if (materialsInStatus == null
            || totalMaterials == null
            || materialsInStatus === 0
            || totalMaterials === 0) {
            return 0;
        }
        return (materialsInStatus / totalMaterials) * 100;
    }

    onRetryClick(): void {
        if (!this.isDisabled) {
            this.retryClick();
        }
    }

    isRetryEnabled(): boolean {
        return this.retryClick != null;
    }
}
